import { isPhone } from '@/utils/common';
import { storage } from '@/utils/storage';
import { buriedCapital } from '@/api/login';
import { buriedPoint } from '@/utils/config';
import { baseDayTimeMethod } from '@/utils/common';
import { pageInitRequest } from '@/hooks/useInitBasic';
import { getBaseUrl, getBaseUrlInformation } from '@/utils/baseUrl';
import { getVoucher } from '@/api/pageResult/ysrIndex';
import { loginRegister } from '@/hooks/useLoginRegister';
const baseUrl = getBaseUrl();
const baseUrlInformation = getBaseUrlInformation();
// console.log(baseUrl, 'baseUrl========');
import router from '@/router/index';
import { IObjStr } from '@/utils/http';

const { buriedPointFn, buriedPointNoTokenFn } = pageInitRequest();
const { getYxCarData } = loginRegister();

export function pageJump() {
  // let baseUrl = '';
  // const router = useRouter();
  // 跳转guide
  // switch (import.meta.env.VITE_USER_NODE_ENV) {
  //   case 'production':
  //     baseUrl = 'https://guide-pro.youhangjh.com';
  //     break;
  //   case 'test':
  //     baseUrl = 'https://guide-test.youhangjh.com';
  //     break;
  //   default:
  //     baseUrl = 'https://guide-test.youhangjh.com';
  // }
  const clickId_ = storage.getItem('clickId', 2) || '';

  const goPageUrl = async (guestUserInfoAuthState: IObjStr) => {
    const carInfo = await getYxCarData();
    let bUrl = '';
    if (guestUserInfoAuthState.blankResult) {
      bUrl =
        baseUrlInformation +
        guestUserInfoAuthState.blankResult +
        `?channelId=${storage.getItem('channelId', 2)}`;
    } else if (carInfo) {
      bUrl =
        baseUrlInformation +
        guestUserInfoAuthState.car +
        `?title=1&channelId=${storage.getItem('channelId', 2)}`;
    } else if (guestUserInfoAuthState.blank) {
      bUrl =
        baseUrlInformation +
        guestUserInfoAuthState.blank +
        `?channelId=${storage.getItem('channelId', 2)}`;
    } else if (guestUserInfoAuthState.guide) {
      bUrl =
        baseUrlInformation +
        guestUserInfoAuthState.guide +
        `?channelId=${storage.getItem('channelId', 2)}`;
    } else if (storage.getItem('guideFromBackground', 2)) {
      bUrl =
        storage.getItem('guideFromBackground', 2) +
        `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
          'token',
          1
        )}&clickId=${clickId_}`;
    } else if (storage.getItem('goNewPage', 2) == 'goNewPage') {
      bUrl =
        baseUrlInformation +
        '/productMatchingSuccess' +
        `?channelId=${storage.getItem('channelId', 2)}`;
    } else if (storage.getItem('guideName', 2)) {
      const guideName = storage.getItem('guideName', 2);
      switch (guideName) {
        case 'yrGuideTwo':
          bUrl =
            baseUrl +
            '/yrGuideTwo' +
            `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
              'token',
              1
            )}&clickId=${clickId_}`;
          break;
        case 'guideYsrOne':
          bUrl =
            baseUrl +
            '/ysrGuideOne' +
            `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
              'token',
              1
            )}&clickId=${clickId_}`;
          break;
        case 'guideXd':
          if (isPhone() == 'IOS') {
            bUrl =
              baseUrl +
              '/ysrGuideOne' +
              `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                'token',
                1
              )}&clickId=${clickId_}`;
          } else {
            bUrl =
              baseUrl +
              '/xdGuideOne' +
              `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                'token',
                1
              )}&clickId=${clickId_}`;
          }
          break;
        case 'guideJl':
          bUrl =
            baseUrl +
            '/jlGuideOne' +
            `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
              'token',
              1
            )}&clickId=${clickId_}`;
          break;
        case 'guideJlTwo':
          bUrl =
            baseUrl +
            '/jlGuideTwo' +
            `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
              'token',
              1
            )}&clickId=${clickId_}`;
          break;
        case 'guideWbOne':
          bUrl =
            baseUrl +
            '/wbGuideOne' +
            `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
              'token',
              1
            )}&clickId=${clickId_}`;
          break;
        case 'guideXdToStore':
          bUrl =
            baseUrl +
            '/xdGuideToStore' +
            `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
              'token',
              1
            )}&clickId=${clickId_}`;
          break;
        case 'guideXd239':
          if (isPhone() == 'IOS') {
            bUrl =
              baseUrl +
              '/ysrGuideOne' +
              `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                'token',
                1
              )}&clickId=${clickId_}`;
          } else {
            bUrl =
              baseUrl +
              '/xdGuideOneTTN' +
              `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                'token',
                1
              )}&clickId=${clickId_}`;
          }
          break;
      }
    }
    const pathname = window.location.pathname;
    if (pathname.indexOf('Login') > -1) {
      bUrl = bUrl + '&fromPageCode=ysr100001';
    } else if (pathname.indexOf('LeaveInfo') > -1) {
      bUrl = bUrl + '&fromPageCode=ysr100002';
    } else if (pathname.indexOf('Loading') > -1) {
      bUrl = bUrl + '&fromPageCode=ysr100003';
    } else if (pathname.indexOf('Result') > -1) {
      bUrl = bUrl + '&fromPageCode=ysr100007';
    }
    const pageFlag = storage.getItem('flag', 2);
    if (pageFlag) {
      bUrl = bUrl + '&flag=' + pageFlag;
    }
    const voucher = await getVoucher();
    return voucher?.voucher ? bUrl + '&voucher=' + voucher.voucher : bUrl;
  };
  async function jump() {
    // 全流程埋点
    const pathname = window.location.pathname;
    const comParams = {
      eventCode: 'JR_H5_USER_PAGE_VIEW',
      currentPageCode: 'ysr100005',
      currentPageName: '下载页',
      fromPageCode: '',
      fromPageName: '',
      fromUrl: pathname,
      logTime: baseDayTimeMethod.getDateTime(),
      extraDataJson: {
        burSystem: 1,
      },
    };
    if (pathname.indexOf('Login') > -1) {
      comParams.fromPageCode = 'ysr100001';
      comParams.fromPageName = '访问页';
    } else if (pathname.indexOf('LeaveInfo') > -1) {
      comParams.fromPageCode = 'ysr100002';
      comParams.fromPageName = '信贷留资页';
    } else if (pathname.indexOf('Loading') > -1) {
      comParams.fromPageCode = 'ysr100003';
      comParams.fromPageName = '提交审核页';
    } else if (pathname.indexOf('Result') > -1) {
      comParams.fromPageCode = 'ysr100007';
      comParams.fromPageName = '撞库成功页';
    }
    // 补充guide 埋点参数
    const pageFlag = storage.getItem('flag', 2);

    if (storage.getItem('token')) {
      // await buriedPointFn(true, [comParams]);
    } else {
      // await buriedPointNoTokenFn(true, [comParams]);
    }
    buriedCapital({ point: buriedPoint.TYPE_download_visit }).finally(() => {
      if (storage.getItem('goNewPage', 2) == 'goNewPage') {
        router.push({ path: '/productMatchingError' });
      } else if (storage.getItem('guideFromBackground', 2)) {
        // channelId必传 ，若为动态Guide页需要根据channelId去查配置信息
        const bUrl =
          storage.getItem('guideFromBackground', 2) +
          `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
            'token',
            1
          )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (window && window.my && window.my.getEnv) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          my.getEnv(function (res) {
            if (res.miniprogram) {
              // 当前是小程序环境，postMessage到webview执行跳转
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              window.my.postMessage({
                actionType: 3,
                url: storage.getItem('token', 1)
                  ? bUrl + `&token=${storage.getItem('token', 1)}`
                  : bUrl,
              });
            } else {
              // 非小程序环境，按原本逻辑执行
              location.href = storage.getItem('token', 1)
                ? bUrl + `&token=${storage.getItem('token', 1)}`
                : bUrl;
            }
          });
        } else {
          window.location.href = storage.getItem('token', 1)
            ? bUrl + `&token=${storage.getItem('token', 1)}`
            : bUrl;
        }
      } else if (storage.getItem('guideName', 2)) {
        const guideName = storage.getItem('guideName', 2);
        switch (guideName) {
          case 'guideYsrOne':
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (window && window.my && window.my.getEnv) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              my.getEnv(function (res) {
                if (res.miniprogram) {
                  // 当前是小程序环境，postMessage到webview执行跳转
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  window.my.postMessage({
                    actionType: 3,
                    url:
                      baseUrl +
                      '/ysrGuideOne' +
                      `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                        'token',
                        1
                      )}&fromPageCode=${
                        comParams.fromPageCode
                      }&flag=${pageFlag}&clickId=${clickId_}`,
                  });
                } else {
                  // 非小程序环境，按原本逻辑执行
                  location.href =
                    baseUrl +
                    '/ysrGuideOne' +
                    `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                      'token',
                      1
                    )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
                }
              });
            } else {
              window.location.href =
                baseUrl +
                '/ysrGuideOne' +
                `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                  'token',
                  1
                )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            }
            break;
          case 'guideXd':
            if (isPhone() == 'IOS') {
              window.location.href =
                baseUrl +
                '/ysrGuideOne' +
                `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                  'token',
                  1
                )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            } else {
              window.location.href =
                baseUrl +
                '/xdGuideOne' +
                `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                  'token',
                  1
                )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            }
            break;
          case 'guideJl':
            window.location.href =
              baseUrl +
              '/jlGuideOne' +
              `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                'token',
                1
              )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            break;
          case 'guideJlTwo':
            window.location.href =
              baseUrl +
              '/jlGuideTwo' +
              `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                'token',
                1
              )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            break;
          case 'guideWbOne':
            window.location.href =
              baseUrl +
              '/wbGuideOne' +
              `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                'token',
                1
              )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            break;
          case 'yrGuideTwo':
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (window && window.my && window.my.getEnv) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              my.getEnv(function (res) {
                if (res.miniprogram) {
                  // 当前是小程序环境，postMessage到webview执行跳转
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  window.my.postMessage({
                    actionType: 3,
                    url:
                      baseUrl +
                      '/yrGuideTwo' +
                      `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                        'token',
                        1
                      )}&fromPageCode=${
                        comParams.fromPageCode
                      }&flag=${pageFlag}&clickId=${clickId_}`,
                  });
                } else {
                  // 非小程序环境，按原本逻辑执行
                  location.href =
                    baseUrl +
                    '/yrGuideTwo' +
                    `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                      'token',
                      1
                    )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
                }
              });
            } else {
              window.location.href =
                baseUrl +
                '/yrGuideTwo' +
                `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                  'token',
                  1
                )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            }
            break;
          case 'guideXdToStore':
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (window && window.my && window.my.getEnv) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              my.getEnv(function (res) {
                if (res.miniprogram) {
                  // 当前是小程序环境，postMessage到webview执行跳转
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  window.my.postMessage({
                    actionType: 3,
                    url:
                      baseUrl +
                      '/xdGuideToStore' +
                      `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                        'token',
                        1
                      )}&fromPageCode=${
                        comParams.fromPageCode
                      }&flag=${pageFlag}&clickId=${clickId_}`,
                  });
                } else {
                  // 非小程序环境，按原本逻辑执行
                  location.href =
                    baseUrl +
                    '/xdGuideToStore' +
                    `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                      'token',
                      1
                    )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
                }
              });
            } else {
              window.location.href =
                baseUrl +
                '/xdGuideToStore' +
                `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                  'token',
                  1
                )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            }
            break;
          case 'guideXd239':
            if (isPhone() == 'IOS') {
              window.location.href =
                baseUrl +
                '/ysrGuideOne' +
                `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                  'token',
                  1
                )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            } else {
              window.location.href =
                baseUrl +
                '/xdGuideOneTTN' +
                `?channelId=${storage.getItem('channelId', 2)}&defined=${storage.getItem(
                  'token',
                  1
                )}&fromPageCode=${comParams.fromPageCode}&flag=${pageFlag}&clickId=${clickId_}`;
            }
            break;
        }
      }
    });
  }

  return {
    jump,
    goPageUrl,
  };
}
